// extracted by mini-css-extract-plugin
export default {"container":"ShiftInputScale_container__gb2Dz","box":"ShiftInputScale_box__EKXHj","inputBox":"ShiftInputScale_inputBox__RZXRy"};